import { Icon } from '@iconify/react';
import { formatCurrency } from './utils';

const LedgerSummaryCards = ({ summary }) => {
    return (
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-4 tw-gap-3 tw-mb-4">
            <div className="tw-bg-white tw-rounded-lg tw-border tw-border-gray-100 tw-px-3 tw-py-1.5 tw-shadow-sm">
                <div className="tw-flex tw-items-center tw-gap-1 tw-leading-none">
                    <Icon icon="mdi:wallet-outline" width={12} height={12} className="tw-text-gray-400 tw-flex-shrink-0" />
                    <span className="tw-text-[10px] tw-text-gray-400 tw-font-medium tw-leading-[12px]">Opening Balance</span>
                </div>
                <p className="tw-text-sm tw-font-bold tw-text-gray-800">
                    <span className="tw-text-xs tw-font-normal tw-text-gray-400 tw-mr-0.5">&#8377;</span>
                    {formatCurrency(summary.openingBalance)}
                </p>
                <p className="tw-text-[9px] tw-text-gray-400">As of {summary.openingDate}</p>
            </div>

            <div className="tw-bg-white tw-rounded-lg tw-border tw-border-gray-100 tw-px-3 tw-py-1.5 tw-shadow-sm">
                <div className="tw-flex tw-items-center tw-gap-1 tw-leading-none">
                    <Icon icon="mdi:trending-up" width={12} height={12} className="tw-text-gray-400 tw-flex-shrink-0" />
                    <span className="tw-text-[10px] tw-text-gray-400 tw-font-medium tw-leading-[12px]">Total Dues (+)</span>
                </div>
                <p className="tw-text-sm tw-font-bold tw-text-orange-500">
                    <span className="tw-text-xs tw-font-normal tw-mr-0.5">&#8377;</span>
                    {formatCurrency(summary.totalDues)}
                </p>
                <p className="tw-text-[9px] tw-text-gray-400">Inc. Maintenance & Late Fees</p>
            </div>

            <div className="tw-bg-white tw-rounded-lg tw-border tw-border-gray-100 tw-px-3 tw-py-1.5 tw-shadow-sm">
                <div className="tw-flex tw-items-center tw-gap-1 tw-leading-none">
                    <Icon icon="mdi:trending-down" width={12} height={12} className="tw-text-gray-400 tw-flex-shrink-0" />
                    <span className="tw-text-[10px] tw-text-gray-400 tw-font-medium tw-leading-[12px]">Total Paid (-)</span>
                </div>
                <p className="tw-text-sm tw-font-bold tw-text-emerald-500">
                    <span className="tw-text-xs tw-font-normal tw-mr-0.5">&#8377;</span>
                    {formatCurrency(summary.totalPaid)}
                </p>
                <p className="tw-text-[9px] tw-text-gray-400">Via UPI & Bank Transfer</p>
            </div>

            <div className="tw-bg-white tw-rounded-lg tw-border tw-border-gray-100 tw-px-3 tw-py-1.5 tw-shadow-sm">
                <div className="tw-flex tw-items-center tw-gap-1 tw-leading-none">
                    <Icon icon="mdi:scale-balance" width={12} height={12} className="tw-text-gray-400 tw-flex-shrink-0" />
                    <span className="tw-text-[10px] tw-text-gray-400 tw-font-medium tw-leading-[12px]">Closing Balance</span>
                </div>
                <p className="tw-text-sm tw-font-bold tw-text-blue-600">
                    <span className="tw-text-xs tw-font-normal tw-mr-0.5">&#8377;</span>
                    {formatCurrency(summary.closingBalance)}
                </p>
                <p className="tw-text-[9px] tw-text-gray-400">Outstanding Balance</p>
            </div>
        </div>
    );
};

export default LedgerSummaryCards;
